import moment from 'moment'

export default class Formatter {

    public static FormatDate(dt: Date): string {
        if (dt) {
            return moment(dt).format("DD/MMM/YYYY");
        }
        else {
            return "";
        }
    }
    public static FormatDateTime(dt: Date): string {
        if (dt) {
            return moment(dt).format("DD/MMM/YY HH:mm");
        }
        else {
            return "";
        }
    }
    public static FormatTime(dt: Date): string {
        if (dt) {
            return moment(dt).format("HH:mm");
        }
        else {
            return "";
        }
    }


    public static HexColour(argb: any): string{
        if (argb.length == 7) return argb;
    //console.log(argb, '#' + ('000000' + (argb & 0xFFFFFF).toString(16)).slice(-6));
    var rgb = '#' + ('000000' + (argb & 0xFFFFFF).toString(16)).slice(-6);
    //console.log('#' + argb.substring(3, 9));
    //return "#e1e1e1";
    return '#' + argb.substring(3, 9);
}
}


// WEBPACK FOOTER //
// ./ClientApp/components/corecontrols/formatters/Formatter.ts